module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Medium-a1c69182a6264d3fa3122e84c6d4fd68.woff";